import React, { useContext } from 'react';
import { FieldSetContainer, FieldSetContent, LegendContainer, StyledRadioButton } from './styled';
import { FieldState, FormState } from 'formstate';
import { AppThemeContext } from '../../../../../../App';
import { intl } from '../../../../../../core/utils/Intl';

interface IRadioYesNo {
  value: boolean;
  label: string;
  disabled?: boolean;
  form?: FormState<any>;
  fieldStateName?: string;
  onChange?: (value: any) => void;
}

export const RadioYesNo = (props: IRadioYesNo) => {
  const { value, label, form, onChange, fieldStateName } = props;
  let formCurrent: FormState<any>;
  if (form === undefined) {
    formCurrent = new FormState<any>({
      radioYesNo: new FieldState<'YES' | 'NO'>(value ? 'YES' : 'NO')
    });
  } else {
    formCurrent = form;
  }

  const themeContext = useContext(AppThemeContext);
  const getRadio = () => {
    return [
      {
        fieldState: fieldStateName ? fieldStateName : 'radioYesNo',
        options: [
          { value: 'YES', label: intl('app.yes', 'YES') },
          { value: 'NO', label: intl('app.no', 'NO') }
        ]
      }
    ];
  };
  return (
    <FieldSetContainer>
      <LegendContainer>{label}</LegendContainer>
      <FieldSetContent bgColorIndicator={themeContext.accent_green}>
        {getRadio().map((item: any, index: number) => (
          <StyledRadioButton
            key={`radioYesNo${index}`}
            options={item.options}
            fill
            noLabel
            disabled={props.disabled}
            id={'radioYesNo'}
            layer={{
              inputWidth: 12,
              labelOrientation: 'start'
            }}
            fieldState={formCurrent.$[item.fieldState]}
            onChange={onChange}
          />
        ))}
      </FieldSetContent>
    </FieldSetContainer>
  );
};
